import NumPad from "components/common/NumPad";
import Widget from "components/common/Widget";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex: 1 1 100%;
`;

export const RowContainer = styled(Container)`
  justify-content: normal;
  flex-direction: row;
  width: 100%;
`;

export const StyledNumpad = styled(NumPad)`
  width: 370px;
`;

export const StyledText = styled.h4`
  margin: 20px 0px;
`;

export const FormGroup = styled.div`
  span {
    display: block;
    margin-bottom: 1rem;
  }
  margin-bottom: 2rem;
`;

export const WidgetWrapper = styled(Widget)`
  height: 100%;
  display: flex;
  padding: 2rem;
  width: 100%;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/common/TabbedContainers.tsx